import NextLink from 'next/link';
import { tv } from 'tailwind-variants';
import useInteractions from 'lib/hooks/useInteractions';

import { Button, Icon, pluralize } from '@frontendmentorio/design-system-v2';

import LikeButton from './LikeButton';
import BookmarkButton from './BookmarkButton';

const styles = tv({
  extend: Button.styles,
  base: [
    'border-0',
    'disabled:bg-white',
    'font-normal',
    'gap-2',
    'hover:bg-white',
    'not-italic',
    'p-0',
    'text-lg',
  ],
});

export default function Activity({ solution }) {
  return (
    <div className="flex gap-3 items-center text-lg">
      <NextLink
        aria-label={`Go to solution feedback. This solution has ${pluralize(
          solution.commentCount,
          'comment'
        )}.`}
        href={`/solutions/${solution.slug}#feedback`}
      >
        <div className="flex gap-2 items-center">
          <Icon className="text-neutral-500" name="message" />
          <span>{solution.commentCount}</span>
        </div>
      </NextLink>

      <LikeButton className={styles()} solution={solution} />
      <BookmarkButton className={styles()} solution={solution} />
    </div>
  );
}
